import { ProductData } from 'types/ProductData';

type ProductValidationProps = {
  product: ProductData;
  count: number;
  marketType: string;
};

type ValidationResult = {
  stock_count: number;
  stock_total: number;
  requires_auth: boolean;
};

export const validateProduct = ({
  product,
  count,
  marketType,
}: ProductValidationProps): ValidationResult => {
  const productAmount = product?.product_amounts?.find(
    (amount) => amount.type === marketType
  );
  const reservation = productAmount?.wholesale_reserve;

  let stock_count = count;
  let price = productAmount?.storage_stock_price || 0;
  let requires_auth = false;

  const storageLimitMin = Math.max(
    productAmount?.storage_limit_min ?? 1,
    productAmount?.step ?? 0
  );

  if (product.subcategory?.customer_auth === 1) {
    requires_auth = true;
  }

  if (stock_count < storageLimitMin) {
    stock_count = storageLimitMin;
  }

  if (
    productAmount?.storage_limit_max &&
    stock_count > productAmount?.storage_limit_max
  ) {
    stock_count = productAmount.storage_limit_max;
  }

  if (
    productAmount?.storage_stock_count !== undefined &&
    stock_count >
      productAmount.storage_stock_count + (reservation?.amount_to ?? 0)
  ) {
    stock_count =
      productAmount.storage_stock_count + (reservation?.amount_to ?? 0);
  }

  if (
    reservation?.amount_from &&
    !productAmount?.storage_stock_count &&
    reservation?.amount_from > count
  ) {
    stock_count = reservation?.amount_from;
  }

  if (
    productAmount?.storage_limit_max &&
    productAmount.storage_limit_max < storageLimitMin
  ) {
    count = 0;
  }

  if (
    productAmount?.storage_stock_count != null &&
    productAmount.storage_stock_count < storageLimitMin
  ) {
    count = 0;
  }

  if (
    productAmount?.storage_stock_discount_price &&
    productAmount.storage_stock_discount_price < price
  ) {
    price = productAmount.storage_stock_discount_price;
  }

  if (
    productAmount?.storage_wholesale_limit &&
    productAmount?.storage_wholesale_price &&
    productAmount.storage_wholesale_price < price &&
    count >= productAmount.storage_wholesale_limit
  ) {
    price = productAmount.storage_wholesale_price;
  }

  return {
    stock_count: stock_count,
    stock_total: parseFloat((stock_count * price).toFixed(2)),
    requires_auth: requires_auth,
  };
};
